import {
  PaymentObjectArguments,
  WalletChargeObjectArguments,
} from "@core/server/domain/request.interface";
import { ServerResponse } from "@core/server/domain/server.interface";
import {
  getFarmerDiscountsApi,
  getFarmerInvoicesApi,
  getWalletTransactionsApi,
  paymentsApi,
  walletBalanceApi,
  walletChargeApi,
} from "@core/server/utils/apis";
import { StatusType } from "@core/workflow/domain/workflow.type";
import {
  Discounts,
  Invoices,
  Payments,
  WalletBalance,
  WalletChargeResponse,
  WalletTransactions,
} from "@/features/financial-management/domain/financial-management.interface";

export interface GetFarmerInvoicesArguments {
  state?: number;
  status: StatusType;
  limit?: number;
  page?: number;
}

export async function getFarmerInvoices(args?: GetFarmerInvoicesArguments) {
  const response: Promise<ServerResponse<Invoices> | undefined> =
    await getFarmerInvoicesApi(args);
  return (await response)?.data.invoices;
}

export async function getFarmerDiscounts() {
  const response: Promise<ServerResponse<Discounts> | undefined> =
    await getFarmerDiscountsApi();
  return (await response)?.data.discounts;
}

export async function walletCharge(requestObject: WalletChargeObjectArguments) {
  const response: Promise<ServerResponse<WalletChargeResponse> | undefined> =
    await walletChargeApi(requestObject);
  return (await response)?.data.walletTransaction;
}

export async function payments({
  walletTransactionId,
  returnTo,
}: PaymentObjectArguments) {
  const response: Promise<ServerResponse<Payments> | undefined> =
    await paymentsApi({ walletTransactionId, returnTo });
  return (await response)?.data;
}

export async function walletBalance() {
  const response: Promise<ServerResponse<WalletBalance> | undefined> =
    await walletBalanceApi();
  return (await response)?.data;
}

export async function walletTransactions() {
  const response: Promise<ServerResponse<WalletTransactions> | undefined> =
    await getWalletTransactionsApi();
  return (await response)?.data.transactions;
}
